import ApiService from "@/common/api.service"

export const TrainerCriteriaService = {
    create(params) {
        return ApiService.post("trainerSelectionCriteria/add", params);
    },
    update(slug, params) {
        return ApiService.update("trainerSelectionCriteria", slug, params);
    },

}